import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from 'vue';

import { useStyle } from '@composables/use-style';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { colors, colorManager, fontStyle } = useStyle();

const style = ref({
  global: {
    fontFamily: fontStyle.FAMILY.PRIMARY,
    fontSize: fontStyle.SIZE.MD,
    fontWeight: fontStyle.WEIGHT.MD,
    minWidth: '100%',
    minHeight: '100vh',
    '-webkit-font-smoothing': 'antialiased',
    'moz-osx-font-smoothing': 'grayscale',
    'scroll-behavior': 'smooth',
  },
});

document.documentElement.style.backgroundColor = colors.BACKGROUND1();

watch(() => colorManager.mode, () => {
  document.documentElement.style.backgroundColor = colors.BACKGROUND1();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(style.value.global)
  }, [
    _createVNode(_component_router_view)
  ], 4))
}
}

})